import { render, staticRenderFns } from "./zhiShiKu.vue?vue&type=template&id=74181199&scoped=true&"
import script from "./zhiShiKu.vue?vue&type=script&lang=js&"
export * from "./zhiShiKu.vue?vue&type=script&lang=js&"
import style0 from "./zhiShiKu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./zhiShiKu.vue?vue&type=style&index=1&id=74181199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74181199",
  null
  
)

export default component.exports